import React, { useState } from 'react';
import stylez from './Login.module.css';
import axios from 'axios';
import UserContext from '../../../Context/UserContext';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../../Configuration/baseUrls';
import logo from '../../../utils/favicon.ico';

const Login = (props) => {
  // SetIsloggedIn to true as soon as the tooken is recieved
  const { setIsLoggedIn } = props;
  const { user, storeUser } = useContext(UserContext);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const loginFunction = async (e) => {
    e.preventDefault();

    try {
      // Post User data to the backend after the user logs in.
      const res = await axios.post(`${BASE_URL}user/login`, data);
      sessionStorage.setItem('token', res.data.data.token);
      sessionStorage.setItem('userRole',res.data.data.user.role);
      sessionStorage.setItem('email',res.data.data.user.email);
      // SessionStorage saves the token.
      storeUser(res.data.data);
      alert('Login successful');
      setIsLoggedIn(true);
      // This sets the LoggedInState to True.
      navigate('/');
      setError('');
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        console.log('error',error);
        console.log(error);
        setError(error.response.data.message);
      }
    }
  };
  const [data, setData] = useState();
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  return (
    <div className={stylez.loginContainer}>

      <div className={stylez.login}>
        <img
          width='40px'
          height='40px'
          style={{ margin: '0 auto' }}
          src={logo}
          alt='Firebrand Logo'
        />
        <h1>Firebrand Australia ERP</h1>
        <div className={stylez.emailBox}>
          <label htmlFor='email'>Enter Email:</label>
          <input
          id='email'
            type='email'
            placeholder='Email'
            name='email'
            onChange={handleChange}
          />
        </div>
        <div className={stylez.passwordBox}>
          <label htmlFor='password'>Enter Password:</label>
          <input
            id='password'
            type='password'
            name='password'
            placeholder='Password'
            onChange={handleChange}
          />
        </div>
        <button className={stylez.loginBtn} onClick={loginFunction}>
          Login
        </button>
        <p>
          Frogot Password?
          <button className={stylez.forgotLink}
            onClick={() => {
            navigate('/forgotPassword');
            }}
          >
            Click Here!
          </button>
        </p>
        {error && <div className={stylez.errorMsg}>❗{error}</div>}
      </div>
    </div>
  );
};
export default Login;
